import React, { useMemo } from 'react';
import {
  Lesson,
  DailyRosterInstructor
} from '@/constants/Interfaces/CommonInterfaces';
import useInstructorRosterStore from '@/stores/instructorRosterStore';
import CalendarHeader from '@/components/DailyRoster/MonthlyCalendar/CalendarHeader';
import CalendarGrid from '@/components/DailyRoster/MonthlyCalendar/CalendarGrid';
import { useCalendarEvents, useCalendarNavigation } from '@/hooks';

interface InstructorMonthlyCalendarProps {
  onLessonClick?: (lesson: Lesson, instructor: DailyRosterInstructor) => void;
}

const InstructorMonthlyCalendar: React.FC<InstructorMonthlyCalendarProps> = ({
  onLessonClick
}) => {
  const { lessonSchedule, selectedDate, setSelectedDate, setSelectedLesson } =
    useInstructorRosterStore();
  // Get current month from selected date
  const currentMonth = useMemo(() => {
    return selectedDate ? new Date(selectedDate) : new Date();
  }, [selectedDate]);

  // Use shared hooks for calendar logic (same visuals/logic as Daily MonthlyCalendar)
  const monthEvents = useCalendarEvents(lessonSchedule as any, currentMonth);
  const { goToPreviousMonth, goToNextMonth, goToToday } = useCalendarNavigation(
    currentMonth,
    setSelectedDate
  );

  const handleLessonClick = (
    lesson: Lesson,
    instructor: DailyRosterInstructor
  ) => {
    setSelectedLesson(lesson);
    onLessonClick?.(lesson, instructor);
  };

  return (
    <div className='bg-white shadow-sm border border-gray-200'>
      <CalendarHeader
        currentMonth={currentMonth}
        onPreviousMonth={goToPreviousMonth}
        onNextMonth={goToNextMonth}
        onGoToToday={goToToday}
      />

      <CalendarGrid
        currentMonth={currentMonth}
        events={monthEvents}
        onLessonClick={handleLessonClick}
      />
    </div>
  );
};

export default InstructorMonthlyCalendar;
